import isObject from 'lodash-es/isObject'

/**
 * Resolves a translation item into a localized string.
 *
 * The `translationItem` argument can be provided in two forms:
 *
 * 1) String — translation key without variables:
 *    'Select.ShowLess'
 *
 * 2) Object — translation key with interpolation values:
 *    {
 *      key: 'Select.ShowAll',
 *      values: { count: items.length }
 *    }
 *
 * In both cases the function will call `t()` from i18n
 * with the correct arguments.
 *
 * @param {Object} params
 * @param {Function} params.t - i18n translation function
 * @param {string|Object} params.translationItem - Translation key or object with key and values
 * @returns {string} Localized string
 */
export function resolveI18n({ t, translationItem }) {
  if (isObject(translationItem)) {
    return t(...Object.values(translationItem))
  } else {
    return t(translationItem)
  }
}

export function getTranslatedOptions({ options, t }) {
  return options.map(option => ({ ...option, label: t(option.label) }))
}
